import type { AdminDashboardPayload, AnswerValue, PublicSettingsPayload, SessionPayload } from "./types";

const JSON_HEADERS = { "content-type": "application/json" };

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, { credentials: "same-origin", ...init });
  if (!response.ok) throw new Error(`Request failed (${response.status})`);
  return response.status === 204 ? (undefined as T) : (await response.json()) as T;
}

export const api = {
  /** The server establishes the public HttpOnly session cookie on this request. */
  getSession: () => request<SessionPayload>("/api/session"),
  publicSettings: () => request<PublicSettingsPayload>("/api/settings/public"),
  saveAnswer: (sessionId: string, questionId: string, answer: AnswerValue) =>
    request<void>("/api/answers", { method: "POST", headers: JSON_HEADERS, body: JSON.stringify({ sessionId, questionId, answer }) }),
  saveFinalReply: (sessionId: string, message: string) =>
    request<void>("/api/final-replies", { method: "POST", headers: JSON_HEADERS, body: JSON.stringify({ sessionId, message }) }),
  adminLogin: (pin: string) => request<{ authenticated: boolean; csrfToken: string; expiresAt: string }>("/api/admin/login", { method: "POST", headers: JSON_HEADERS, body: JSON.stringify({ pin }) }),
  adminDashboard: () => request<AdminDashboardPayload>("/api/admin/dashboard"),
  deleteRespondent: (sessionId: string, csrfToken: string) => request<void>(`/api/admin/respondents/${encodeURIComponent(sessionId)}`, { method: "DELETE", headers: { "x-csrf-token": csrfToken } }),
  saveFinalMessage: (message: string, csrfToken: string) => request<void>("/api/admin/settings/final-message", { method: "PUT", headers: { ...JSON_HEADERS, "x-csrf-token": csrfToken }, body: JSON.stringify({ message }) }),
  adminLogout: (csrfToken: string) => request<void>("/api/admin/logout", { method: "POST", headers: { "x-csrf-token": csrfToken } }),
};
